module.exports = __webpack_public_path__ + "static/media/query-builder-header-ico.e5fea523.svg";